module.exports = __webpack_public_path__ + "static/media/microsoftstore.5989a415.svg";